// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_RMi","cls2":"NewsInteractionBar-cls2_Qct NewsInteractionBar-cls1_RMi"};